import { render, staticRenderFns } from "./LOGISTICS_NUMBER.vue?vue&type=template&id=296eeb1d"
import script from "./LOGISTICS_NUMBER.vue?vue&type=script&lang=js"
export * from "./LOGISTICS_NUMBER.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports